import { Headphones, LayoutGrid } from "lucide-react";
import { Link } from "react-router-dom";
import { HELP_RED, MOBILE_TASK_HEADER_CSS, TABLETOP_LOGO_SRC } from "@/lib/productionDriverPageStyles";
import { useDriverLangMaybe } from "@/context/DriverLanguageContext";
import { shouldShowTsHomeNav } from "@/lib/tsIdentity";
import { staffHomePath } from "@/lib/teamHub";

export default function MobileTaskHeader({
  title,
  subtitle = "The Table Top",
  helpTel = null,
  compact = true,
  showLangToggle = false,
  showTsHome = false,
}) {
  const driverLang = useDriverLangMaybe();
  const langBtn =
    showLangToggle && driverLang ? (
      <button
        type="button"
        className="driver-lang-btn"
        onClick={driverLang.toggleLang}
        aria-label={
          driverLang.lang === "hi"
            ? driverLang.t("langSwitchAriaToEn")
            : driverLang.t("langSwitchAriaToHi")
        }
      >
        {driverLang.lang === "hi"
          ? driverLang.t("langSwitchToEn")
          : driverLang.t("langSwitchToHi")}
      </button>
    ) : null;
  const helpLabel = showLangToggle && driverLang ? driverLang.t("help") : "Help";
  const subtitleText =
    showLangToggle && driverLang ? driverLang.t("brandSubtitle") : subtitle;
  const tbHomeBtn =
    showTsHome && shouldShowTsHomeNav() ? (
      <Link to={staffHomePath()} className="driver-ts-home-btn" aria-label="Home">
        <LayoutGrid size={16} aria-hidden />
      </Link>
    ) : null;

  return (
    <>
      <style>{MOBILE_TASK_HEADER_CSS}</style>
      <style>{`
        .driver-ts-home-btn {
          display: inline-flex; align-items: center; justify-content: center;
          width: 32px; height: 32px; border-radius: 10px;
          background: rgba(238, 38, 119, 0.1); color: ${HELP_RED || "#EE2677"};
          text-decoration: none; flex-shrink: 0;
        }
      `}</style>
      <div className={`driver-top ${compact ? "driver-top--compact" : ""}`}>
        <div className="driver-brand">
          <div className="driver-logo driver-logo--brand">
            <img src={TABLETOP_LOGO_SRC} alt="The Table Top" />
          </div>
          <div>
            <div className="driver-title">{title}</div>
            {!compact ? <div className="driver-subtitle">{subtitleText}</div> : null}
          </div>
        </div>
        {langBtn || helpTel || tbHomeBtn ? (
          <div className="driver-top-actions">
            {tbHomeBtn}
            {langBtn}
            {helpTel ? (
              <a href={helpTel} className="driver-help-btn" aria-label={helpLabel}>
                <Headphones size={14} aria-hidden />
                {helpLabel}
              </a>
            ) : null}
          </div>
        ) : null}
      </div>
    </>
  );
}
